// import React, { useState } from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Button,
//   Card as MuiCard,
//   CardMedia,
//   CardContent,
//   FormControlLabel,
//   Checkbox,
//   Avatar,
//   Paper,
//   Divider,
// } from "@mui/material";
// import { color, styled, width } from "@mui/system";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import FilterDataCard from "../../components/common/FilterDataCard";
// import PlotSlider from "../../components/common/FeaturedCard";
// import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
// import GiooPlot_card from "../../components/common/GiooPlot-card";
// import Syndicate_properties_card from "./Syndicate_properties_card";
// import ReferFriends from "../../components/common/ReferFriends";
// import { yellow } from "@mui/material/colors";
// import theme from "../../utils/theme";
// import ChatModal from "./chats/ChatsModal";
// import { FitScreen } from "@mui/icons-material";
// // import { useState } from "react";

// const Card = styled(MuiCard)(({ theme }) => ({
//   maxWidth: 345,
//   margin: "auto",
//   borderRadius: theme.spacing(2),
//   overflow: "hidden",
// }));

// export default function SyndicatePlots() {
//   const [open, setOpen] = useState(false);

//   const plotsdata = [
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.secondary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.secondary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.secondary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.dark,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.secondary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.secondary.light,
//     },
//     {
//       name: "part - 1",
//       status: "unselected",
//       color: theme.palette.primary.light,
//     },
//   ];

//   const cards = [
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1553194587-b010d08c6c56?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Beachfront",
//       pricePerDay: "$99",
//       title: "A Trip to the Bahamas and the Caribbean Ocean",
//       trendingText: "Trending",
//       durationText: "7 Days Tour",
//       locationText: "Africa",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },

//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//     {
//       imageSrc:
//         "https://images.unsplash.com/photo-1584200186925-87fa8f93be9b?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80",
//       type: "Cruise",
//       pricePerDay: "$169",
//       title: "Cruise to the Mariana Trench and the Philippines",
//       trendingText: "Trending",
//       durationText: "15 Days Tour",
//       locationText: "Australia",
//     },
//   ];

//   const people = [
//     { name: "John Doe", email: "john@example.com" },
//     { name: "Sarah Smith", email: "sarah@example.com" },
//     { name: "Michael Lee", email: "mike@example.com" },
//     { name: "Aisha Khan", email: "aisha@example.com" },
//     { name: "John Doe", email: "john@example.com" },

//     { name: "Aisha Khan", email: "aisha@example.com" },
//     { name: "Aisha Khan", email: "aisha@example.com" },
//     { name: "John Doe", email: "john@example.com" },

//     { name: "Aisha Khan", email: "aisha@example.com" },
//   ];

//   const steps = [
//     {
//       icon: "/assets/icons/support.png",
//       label: "Pay ₹5,000 for Land Document Verification",
//     },
//     {
//       icon: "/assets/icons/support.png",
//       label: "Pay ₹5,000 for Land Document Verification",
//     },
//     {
//       icon: "/assets/icons/support.png",
//       label: "Pay ₹5,000 for Land Document Verification",
//     },
//     {
//       icon: "/assets/icons/support.png",
//       label: "Pay ₹5,000 for Land Document Verification",
//     },
//   ];

//   return (
//     <Container sx={{ py: 5 }}>
//       <Button
//         onClick={() => setOpen(true)}
//         variant="contained"
//         sx={{
//           position: "fixed",
//           bottom: 24,
//           right: 24,
//           width: 70,
//           height: 70,
//           minWidth: 0,
//           padding: 0,
//           borderRadius: "50%",
//           overflow: "hidden", // IMPORTANT
//           boxShadow: 3,
//           bgcolor: "transparent", // remove background
//         }}
//       >
//         <img
//           src="/assets/images/groupchat.png"
//           alt="group chat"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover", // IMPORTANT
//           }}
//         />
//       </Button>

//       <ChatModal open={open} onClose={() => setOpen(false)} />

//       <Box sx={{ mb: 3 }}>
//         <BreadcrumbsNav />
//       </Box>

//       <Box
//         sx={{
//           display: { sm: "block", md: "flex" },
//           gap: 3,
//           alignItems: "flex-start",
//           mb: 2,
//         }}
//       >
//         <Box
//           sx={{
//             flex: { sm: "1 1 100%", md: "0 0 25%" },
//             position: { sm: "static", md: "sticky" },
//             top: 80,
//           }}
//         >
//           <Syndicate_properties_card />
//         </Box>

//         <Box sx={{ mt: { xs: 4, md: 0 } }}>
//           <Typography sx={{ color: "#495057", fontWeight: 600 }}>
//             Plot Purchase Scheme Overview
//           </Typography>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               py: 4,
//               position: "relative",
//             }}
//           >
//             {steps.map((step, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   position: "relative",
//                   flex: "1 1 0", // makes each step take equal space
//                 }}
//               >
//                 {/* Circle */}
//                 <Box
//                   sx={{
//                     width: 80,
//                     height: 80,
//                     borderRadius: "50%",
//                     border: "3px solid #92AF5D",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     backgroundColor: "#fff",
//                     zIndex: 1, // ensure circle is above the line
//                   }}
//                 >
//                   <img
//                     src={step.icon}
//                     alt={step.label}
//                     style={{ width: 40, height: 40 }}
//                   />
//                 </Box>

//                 {/* Text */}
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     mt: 1.5,
//                     textAlign: "center",
//                     mx: 3,
//                     color: "text.secondary",
//                     fontWeight: 400,
//                     maxWidth: 200,
//                     fontSize: 15,
//                     wordWrap: "break-word",
//                   }}
//                 >
//                   {step.label}
//                 </Typography>

//                 {/* Connector line */}
//                 {index !== steps.length - 1 && (
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: "40px",
//                       left: "50%",
//                       width: "100%",
//                       borderBottom: "2px dashed #92AF5D", // <-- dashed line
//                       zIndex: 0, // behind the circle
//                     }}
//                   />
//                 )}
//               </Box>
//             ))}
//           </Box>

//           {/* Plots Slots Booking     */}

//           <Box
//             sx={{
//               height: 350,
//               width: "100%",
//               backgroundImage: "url(/assets/images/plootbg.png)",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//               borderRadius: "20px",
//               p: 2,
//             }}
//           >
//             {/* HEADER SECTION */}
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 mb: 2, // spacing below header
//               }}
//             >
//               {/* LEFT TITLE */}
//               <Typography
//                 variant="h6"
//                 sx={{
//                   mx: 3,
//                   color: "text.secondary",
//                   fontWeight: 400,
//                   fontSize: 15,
//                 }}
//               >
//                 Plot Split-Up
//               </Typography>

//               {/* RIGHT STATUS ITEMS */}
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography
//                   variant="h6"
//                   sx={{ mx: 3, color: "text.secondary", fontSize: 15 }}
//                 >
//                   Status:
//                 </Typography>

//                 {/* Selected */}
//                 <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
//                   <Box
//                     sx={{
//                       height: 20,
//                       width: 20,
//                       borderRadius: "5px",
//                       bgcolor: theme.palette.secondary.main,
//                     }}
//                   />
//                   <Typography sx={{ ml: 1.5, fontSize: 15 }}>
//                     Selected (1)
//                   </Typography>
//                 </Box>

//                 {/* Booked */}
//                 <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
//                   <Box
//                     sx={{
//                       height: 20,
//                       width: 20,
//                       borderRadius: "5px",
//                       bgcolor: theme.palette.secondary.main,
//                     }}
//                   />
//                   <Typography
//                     sx={{ ml: 1.5, color: "text.secondary", fontSize: 15 }}
//                   >
//                     Booked (6)
//                   </Typography>
//                 </Box>

//                 {/* Available */}
//                 <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
//                   <Box
//                     sx={{
//                       height: 20,
//                       width: 20,
//                       borderRadius: "5px",
//                       bgcolor: theme.palette.primary.light,
//                     }}
//                   />
//                   <Typography
//                     sx={{ ml: 1.5, color: "text.secondary", fontSize: 16 }}
//                   >
//                     Available (5)
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             <Box sx={{ width: "100%" }}>
//               <Grid container spacing={2}>
//                 {plotsdata.map((data, index) => (
//                   <Grid item xs={2} key={index}>
//                     <Box
//                       sx={{
//                         bgcolor: data.color,
//                         p: 2,
//                         borderRadius: "8px",
//                         border: "1px solid #ccc",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Typography sx={{ fontSize: 14, color: "white" }}>
//                         {data.name}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>
//             <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
//               <Button
//                 sx={{
//                   //   mx: ,
//                   borderRadius: "16px",
//                   bgcolor: "white",
//                   color: "black",
//                   padding: "8px 36px",
//                   boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
//                 }}
//               >
//                 Reserve Selected Plots
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           display: { xs: "block", md: "flex" },
//           gap: 3,
//           alignItems: "flex-start",
//         }}
//       >
//         {/* Left Column */}
//         <Box sx={{ flex: 2 }}>
//           {/* First Legal Document Section */}
//           <Box
//             sx={{
//               py: 2,
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 2,
//               flexDirection: { xs: "row", sm: "row" },
//             }}
//           >
//             <Box
//               sx={{ minWidth: 50, display: "flex", justifyContent: "center" }}
//             >
//               <img
//                 src="/assets/icons/support.png"
//                 alt="support icon"
//                 style={{ width: 80, height: "auto" }}
//               />
//             </Box>

//             <Box
//               sx={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "column", md: "row" }, // stack on small screens
//                 gap: 2,
//                 alignItems: { xs: "stretch", md: "flex-start" }, // stretch text/buttons on mobile
//               }}
//             >
//               <Box sx={{ flex: 1 }}>
//                 <Typography
//                   variant="h5"
//                   fontWeight={6500}
//                   sx={{ py: 1, fontSize: { xs: 18, sm: 20, md: 22 } }}
//                 >
//                   Legal Document
//                 </Typography>

//                 <Typography
//                   sx={{ mb: 1, fontSize: { xs: 14, sm: 16, md: 18 } }}
//                   color="text.secondary"
//                 >
//                   View and download plot registry, NOC.
//                 </Typography>

//                 <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     sx={{ textTransform: "none" }}
//                   >
//                     View
//                   </Button>

//                   <Button
//                     variant="contained"
//                     sx={{
//                       backgroundColor: "#FEB821",
//                       color: "#000",
//                       textTransform: "none",
//                       "&:hover": { backgroundColor: "#e4a61b" },
//                     }}
//                   >
//                     Download Layout
//                   </Button>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           <Divider
//             sx={{
//               my: 3,
//               width: "60%",
//               borderColor: "#FEB821",
//               borderBottomWidth: "2px",
//               display: { xs: "none", md: "block" },
//             }}
//           />

//           <Box
//             sx={{
//               py: 2,
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 2,
//               flexDirection: { xs: "row", sm: "row" },
//             }}
//           >
//             <Box
//               sx={{ minWidth: 50, display: "flex", justifyContent: "center" }}
//             >
//               <img
//                 src="/assets/icons/support.png"
//                 alt="support icon"
//                 style={{ width: 80, height: "auto" }}
//               />
//             </Box>

//             <Box
//               sx={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "column", md: "row" }, // stack on small screens
//                 gap: 2,
//                 alignItems: { xs: "stretch", md: "flex-start" }, // stretch text/buttons on mobile
//               }}
//             >
//               <Box sx={{ flex: 1 }}>
//                 <Typography
//                   variant="h5"
//                   fontWeight={6500}
//                   sx={{ py: 1, fontSize: { xs: 18, sm: 20, md: 22 } }}
//                 >
//                   Legal Document
//                 </Typography>

//                 <Typography
//                   sx={{ mb: 1, fontSize: { xs: 14, sm: 16, md: 18 } }}
//                   color="text.secondary"
//                 >
//                   View and download plot registry, NOC.
//                 </Typography>

//                 <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     sx={{ textTransform: "none" }}
//                   >
//                     View
//                   </Button>

//                   <Button
//                     variant="contained"
//                     sx={{
//                       backgroundColor: "#FEB821",
//                       color: "#000",
//                       textTransform: "none",
//                       "&:hover": { backgroundColor: "#e4a61b" },
//                     }}
//                   >
//                     Download Layout
//                   </Button>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>

//         {/* Right-side card */}
//         <Box sx={{ flex: 2 }}>
//           <Box
//             sx={{
//               position: "relative",
//               my: 2,
//               borderRadius: 3,
//               overflow: "hidden",
//               border: "1px solid #E0E0E0",
//               boxShadow: 1,
//               backgroundImage: "url('/assets/images/service_cat_bg.png')",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               minHeight: 250,
//               width: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               p: 2,
//               color: "#000",
//             }}
//           >
//             <Typography
//               sx={{
//                 backgroundColor: "rgba(255,255,255,0.7)",
//                 px: 2,
//                 py: 1,
//                 borderRadius: 1,
//                 fontWeight: 600,
//                 fontSize: 18,
//                 textAlign: "center",
//                 mb: 1,
//               }}
//             >
//               Land Document Verification
//             </Typography>

//             <Box
//               component="ul"
//               sx={{
//                 px: 10,
//                 m: 0,
//                 listStyleType: "disc",
//                 fontSize: 20,
//                 fontWeight: 400,
//                 lineHeight: 1.5,
//                 textAlign: "start",
//               }}
//             >
//               <li>Before purchasing, ensure your land is legally verified.</li>
//               <li>
//                 Verify the property documents for complete peace of mind before
//                 you invest.
//               </li>
//               <li>Pay ₹5,000 for instant verification.</li>
//             </Box>

//             <Box
//               sx={{ display: "flex", justifyContent: "center", width: "100%" }}
//             >
//               <Button
//                 variant="contained"
//                 sx={{
//                   borderRadius: 10,
//                   px: 7,
//                   my: 2,
//                   backgroundColor: "#FEB821",
//                   color: "#000",
//                   textTransform: "none",
//                   "&:hover": { backgroundColor: "#e4a61b" },
//                 }}
//               >
//                 Pay Now
//               </Button>
//             </Box>
//           </Box>

//           <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Checkbox sx={{ color: "#92AF5D" }} />
//               <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
//                 I agree to the terms and conditions
//               </Typography>
//             </Box>

//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Checkbox sx={{ color: "#92AF5D" }} />
//               <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
//                 I have verified my land documents
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       <ReferFriends />
//       <Divider
//         sx={{
//           borderColor: "#D9D9D9",
//           borderBottomWidth: 3,
//           my: 2,
//         }}
//       />

//       <Box sx={{ mt: 4 }}>
//         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//           {" "}
//           Slots Filled: 6/11 (Already booked list)
//         </Typography>
//         <Typography>Plot Buyers info in group</Typography>

//         <Box
//           sx={{
//             width: "100%",
//             p: 3,
//             my: 3,
//             borderRadius: 3,
//             boxShadow: 3,
//             backgroundColor: "#fff",
//           }}
//         >
//           <Box
//             sx={{
//               maxHeight: people.length > 8 ? 250 : "auto",
//               overflowY: people.length > 8 ? "auto" : "visible",
//               pr: 1, // space for scrollbar
//             }}
//           >
//             <Grid container columnSpacing={8} rowSpacing={5}>
//               {people.map((person, index) => (
//                 <Grid item xs={12} sm={6} md={3} key={index}>
//                   <Box
//                     sx={{
//                       p: 2,

//                       borderBottom: "1px solid",
//                       borderColor: "secondary.main",
//                       display: "flex",
//                       flexDirection: "row",
//                       alignItems: "center",
//                       gap: 2,
//                       width: "100%",
//                     }}
//                   >
//                     <Avatar
//                       sx={{ width: 45, height: 45 }}
//                       src="/assets/images/profile2.png"
//                     ></Avatar>

//                     <Box sx={{ display: "flex", flexDirection: "column" }}>
//                       <Typography variant="subtitle1" fontWeight={600}>
//                         {person.name}
//                       </Typography>

//                       <Typography
//                         color="text.secondary"
//                         sx={{ fontSize: 12, mt: 0.5 }}
//                       >
//                         {person.email}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>
//         </Box>
//       </Box>
//     </Container>
//   );
// }
import React from "react";
import { Container, Box, Stack } from "@mui/material";
import { useState, useEffect } from "react";
import FilterDataCard from "../../components/common/FilterDataCard";
import PlotSlider from "../../components/common/FeaturedCard";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import { get_syndicate_fun } from "../../api/ControllApi";
import { Skeleton } from "@mui/material";
import { FastField } from "formik";
import IconButton from "@mui/material/IconButton";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

import { Card, CardContent, CardMedia, Typography, Button, Grid } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Syndicate_Card from "./Syndicate_Card";
import SyndicateGridview from "./SyndicateGridview";
import SyndicateGridView from "./SyndicateGridview";
import { useSettings } from "../../context/Settings";
import DescriptionNote from "../../components/common/DescriptionNote";

const SyndicatePlots = () => {
  const { settings } = useSettings();
  const [syndicateData, setSyndicateData] = useState([]);
  const [resp, setResp] = useState([])
  const [propertyType, setPropertyType] = useState([])
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("grid");
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const getSyndicateList = async (filters = {}, page = 1) => {
    setLoading(true);

    try {
      const params = {};

      if (filters.states) params.state = filters.states;
      if (filters.city) params.city = filters.city;

      if (filters.plotType && filters.plotType.length > 0) {
        params['plot_type[]'] = filters.plotType;
      }

      if (filters.priceRange && filters.priceRange.length === 2) {
        params.min_price = filters.priceRange[0];
        params.max_price = filters.priceRange[1];
      }

      if (filters.areaRange && filters.areaRange.length === 2) {
        params.min_sqft = filters.areaRange[0];
        params.max_sqft = filters.areaRange[1];
      }

      if (filters.searchQuery?.trim()) params.search = filters.searchQuery.trim();



      // Call API
      const res = Object.keys(params).length > 0 || page > 0
        ? await get_syndicate_fun(params, page)
        : await get_syndicate_fun();

      // Set state from response
      setSyndicateData(res?.data?.syndicate || []);
      setPropertyType(res?.data?.property_type || []);
      setResp(res?.data || {});
      setPagination(
        res?.data?.pagination || { current_page: 1, last_page: 1 }
      );

    } catch (err) {

      setSyndicateData([])
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSyndicateList();
  }, []);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, current_page: page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
    getSyndicateList({}, page);
  };


  const handleFilterChange = (filters) => {
    getSyndicateList(filters, 1);
  };

  return (
    <Container sx={{ py: 5 }}>
      <Box sx={{ mb: 2 }}>
        <BreadcrumbsNav />
      </Box>
      {settings?.data?.syndicate_description && (
        <DescriptionNote description={settings.data.syndicate_description} />
      )}
      {/* View toggle */}
      <Box display="flex" justifyContent="flex-end" mr={1.5}>
        <IconButton color={view === "grid" ? "primary" : "default"} onClick={() => setView("grid")}>
          <Box key={view === "grid" ? "grid-active" : "grid-idle"} component="span"
            sx={{ display: "flex", ...(view === "grid" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(-20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewModuleIcon />
          </Box>
        </IconButton>
        <IconButton color={view === "list" ? "primary" : "default"} onClick={() => setView("list")}>
          <Box key={view === "list" ? "list-active" : "list-idle"} component="span"
            sx={{ display: "flex", ...(view === "list" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewListIcon />
          </Box>
        </IconButton>
      </Box>



      <Box
        sx={{
          display: { sm: "block", lg: "flex" },
          gap: 0.5,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: { xs: "80%", sm: "50%", lg: 0 },
            mx: "auto",
            flex: { xs: "0 0 50%", sm: "0 0 50%", md: "0 0 22%" },
            position: { xs: "static", lg: "sticky" }, // sticky only on desktop
            top: { md: 115 }, // top offset only for desktop
            mb: { xs: 2, md: 0 }, // spacing for mobile
            mt: { xs: 1 }
          }}
        >
          <FilterDataCard onFilterChange={handleFilterChange} PropertyType={propertyType} priceMax={resp?.price_max} priceMin={resp?.price_min} stateList={resp?.state_list} areaMax={resp?.sqft_max} areaMin={resp?.sqft_min} />
        </Box>
        <Box
          key={view}
          sx={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: view === "grid" ? {
              xs: "1fr",
              sm: "0.5fr 0.5fr ",
              md: "1fr 1fr",
              lg: "1fr 1fr",
            } : { xs: "1fr", sm: "1fr", md: "1fr 1fr", lg: "1fr", xl: "1fr" },
            gap: 5,
            ml: { xs: 0, lg: 8 },
            mt: { xs: 3, lg: 0 },
            px: 2,
            py: 2,
            // container entrance
            animation: "viewEnter 0.35s cubic-bezier(0.34,1.2,0.64,1) both",
            "@keyframes viewEnter": {
              "0%": { opacity: 0, transform: "scale(0.97) translateY(14px)" },
              "60%": { opacity: 1, transform: "scale(1.005) translateY(-2px)" },
              "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
            },
            // stagger each direct child card
            "& > *": {
              animation: "cardSlideIn 0.42s cubic-bezier(0.34,1.2,0.64,1) both",
              "@keyframes cardSlideIn": {
                "0%": { opacity: 0, transform: "translateY(20px) scale(0.96)" },
                "70%": { opacity: 1, transform: "translateY(-3px) scale(1.01)" },
                "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
              },
            },
            "& > *:nth-of-type(1)": { animationDelay: "0.04s" },
            "& > *:nth-of-type(2)": { animationDelay: "0.09s" },
            "& > *:nth-of-type(3)": { animationDelay: "0.14s" },
            "& > *:nth-of-type(4)": { animationDelay: "0.19s" },
            "& > *:nth-of-type(5)": { animationDelay: "0.24s" },
            "& > *:nth-of-type(6)": { animationDelay: "0.29s" },
            "& > *:nth-of-type(n+7)": { animationDelay: "0.32s" },
          }}
        >
          {loading
            ? Array.from(new Array(6)).map((_, index) => (

              view == "grid" ? <Card
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "column" },
                  borderRadius: 4,
                  p: 1,
                  overflow: "hidden",
                  width: "100%",
                  mx: "auto",
                  gap: 4,
                }}
              >
                {/* LEFT IMAGE SKELETON */}
                <Skeleton
                  variant="rectangular"
                  sx={{
                    width: { xs: "100%", sm: 350 },
                    height: { xs: 180, sm: 220 },
                    borderRadius: 3,
                  }}
                  animation="wave"
                />

                {/* RIGHT SIDE SKELETON */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    py: 1,
                  }}
                >
                  <Box>
                    <Skeleton variant="text" width="60%" height={28} animation="wave" />
                    <Skeleton variant="text" width="40%" height={22} animation="wave" sx={{ mt: 1 }} />
                    <Skeleton variant="text" width="50%" height={28} animation="wave" sx={{ mt: 2 }} />
                    <Skeleton variant="text" width="30%" height={20} animation="wave" sx={{ mt: 1 }} />
                  </Box>

                  {/* Button Skeleton */}
                  <Skeleton
                    variant="rectangular"
                    height={42}
                    animation="wave"
                    sx={{
                      borderRadius: 2,
                      mt: 2,
                    }}
                  />
                </Box>
              </Card> :
                <Box
                  key={index}
                  sx={{
                    width: "100%",
                    maxWidth: 780,
                    minHeight: { xs: 150, md: 200 },
                    backgroundColor: "#f0f0f0",
                    borderRadius: 5,
                    display: "flex",
                    flexDirection: { xs: "column-reverse", lg: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: { xs: 2, md: 5 },
                    ml: { xs: 0, lg: 4 },
                    py: { xs: 4, md: 3 },
                    gap: { xs: 2, md: 3 },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "100%", md: "50%" },
                      maxWidth: 400,
                      aspectRatio: "4/3",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                  </Box>
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Skeleton variant="text" width="60%" height={30} />
                    <Skeleton variant="text" width="40%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="rectangular" width="100px" height={40} />
                  </Box>


                </Box>


            ))
            : syndicateData?.length > 0
              ? syndicateData.map((card, index) => (
                <Box sx={{ mb: 1.5 }} key={index}>
                  {view === "grid" ? (
                    <SyndicateGridView
                      name={card?.name}
                      price={card?.price}
                      id={card?.id}
                      image={card?.image[0]}
                      nearby={card?.nearby_locations}
                      amenity={card?.amenity}
                      area={card?.area}
                      address={`${card?.city?.city_name || "Chennai"}, ${card?.state?.state_name || "TamilNadu"}`}
                      soldStatus={card?.sold_status}
                    />
                  ) : (
                    <Syndicate_Card
                      name={card?.name}
                      nearby={card?.nearby_locations}
                      price={card?.price}
                      id={card?.id}
                      image={card?.image[0]}
                      area={card?.area}
                      amenity={card?.amenity}
                      address={`${card?.city?.city_name || "Chennai"}, ${card?.state?.state_name || "TamilNadu"}`}
                      soldStatus={card?.sold_status}
                    />
                  )}
                </Box>
              ))
              : (
                <Box
                  sx={{
                    gridColumn: "1 / -1", // span all columns of the grid
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh",
                    textAlign: "center",
                    width: "100%",
                    py: 5,
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/images/nodatafound.png"
                    alt="No Data Found"
                    sx={{ width: { xs: 320, sm: 350, md: 380 }, mb: 2 }}
                  />
                  {/* Optional text */}
                  {/* <Typography variant="subtitle1" color="text.secondary">
      No Data Found
    </Typography> */}
                </Box>)
          }



        </Box>


      </Box>
      {/* {pagination.last_page > 1 && ( */}
      {syndicateData?.length > 0 && pagination.last_page > 1 && (<Stack direction="row" spacing={1} justifyContent="center" mt={5}>
        {Array.from(
          { length: pagination.last_page },
          (_, i) => i + 1
        ).map((page) => (
          <Button
            key={page}
            variant={
              page === pagination.current_page ? "contained" : "outlined"
            }
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Button>
        ))}
      </Stack>)}
      {/* )} */}
    </Container>
  );
};

export default SyndicatePlots;
